require("!!/home/tapan/www/gp/blockery/node_modules/script-loader/addScript.js")(require("!!/home/tapan/www/gp/blockery/node_modules/raw-loader/index.js!/home/tapan/www/gp/blockery/assets/Yummy/js/scripts.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./assets/Yummy/js/scripts.js
// module id = 66
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20